import { Mic } from 'lucide-react'
import React, { Suspense, useState } from 'react'
import CustomCarousel from '../CustomCarousel/CustomCarousel'
import MediaModal from '../Modals/MediaModal/MediaModal';
import { Link } from '@remix-run/react';
import { getRegionUrlPrefix } from '~/lib/helpers/slugHelper';

const PodcastSection = ({ media, country }) => {
  const [mediaModal, setMediaModal] = useState(false);
  const [currentMedia, setCurrentMedia] = useState(null);
  return (
    <section className="">
      {mediaModal && (
        <Suspense fallback={<div className="p-4">Loading...</div>}>
          < MediaModal media={currentMedia} setVisible={setMediaModal} />
        </Suspense >
      )}
      <div className="flex justify-between items-end my-6">
        <h2 className="text-xl font-bold leading-none">OFFICE HUB OFFICIAL PODCASTS</h2>
        <div className="hidden md:block h-[2px] bg-[#D946EF] flex-1 mx-4" />
        <Link
          to={`${getRegionUrlPrefix(country)}/blog/podcast`}
          className="hidden md:block text-sm text-[#D946EF] hover:underline leading-none"
        >
          See more Podcasts
        </Link>
      </div>

      <div className="">
        <CustomCarousel items={media?.length ? media.map((audio, idx) => (
          <div
            key={idx}
            className="rounded-lg border  hover:shadow-lg transition w-full md:w-[45.5%] lg:w-[350px] flex-shrink-0"
          >
            <div className="relative">
              <img
                src={`https://ik.imagekit.io/officehub/tr:h-960,fo-auto,f-avif/${audio.thumbnail}`}
                alt={audio.title}
                className="w-full h-48 object-cover rounded-t-lg"
              />
              <button onClick={() => {
                // setCurrentMedia(audio)
                setCurrentMedia({
                  ...audio,
                  title: audio.name,
                });
                setMediaModal(true)
              }} className="absolute inset-0 flex items-center justify-center bg-black/40 text-white rounded-t-lg">
                <Mic className="w-10 h-10" />
              </button>

            </div>
            <div className="p-4">

              <p className="text-sm font-semibold mb-2 line-clamp-1">
                {audio.title}
              </p>
              <div className="flex justify-between text-xs text-gray-500">
                <span>{audio.duration}</span>
                <span>{audio.date}</span>
              </div>
            </div>
          </div>
        )) : []} />
      </div>
    </section >
  )
}

export default PodcastSection